import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConnectedSkillAutocomplete } from 'shared/components';

import { ReasonInputBaseProps } from './BaseInput';
import FieldFreeText from './FieldFreeText';

export default function SkillsInput(props: ReasonInputBaseProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails.reasonInput.skills' });
    const { control } = props;

    return (
        <>
            <Typography variant="subtitle2">{ t('label') }</Typography>
            <ConnectedSkillAutocomplete control={ control }
                multiple
                name="reasonInput.skills" />
            <FieldFreeText control={ props.control } />
        </>
    );
}
